import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { TypedMemo } from '../../../common/types';
import { editorMessages } from '../editorMessages';
import { blockMessages } from './blockMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for several parts; each part uses its own slice of it */
import styles from './SMLUndoToast.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SMLUndoToastProps {
  message: string;
  /** Left out for a plain notice (a failed delete). */
  onUndo?: () => void;
  onClose: () => void;
}

/** The toast of a deleted block: "Block "Tickets" deleted. Undo" (design d10). */
const SMLUndoToastComponent: React.FC<SMLUndoToastProps> = ({ message, onUndo, onClose }) => {
  const intl = useIntl();
  return (
    <div className={styles.toast} role="status" aria-live="polite" data-testid="editor-undo-toast">
      <FontAwesomeIcon icon={faCheck} className={styles.icon} />
      <span className={styles.text}>{message}</span>
      {onUndo !== undefined && (
        <button type="button" className={styles.undo} onClick={onUndo}>
          {intl.formatMessage(blockMessages.undo)}
        </button>
      )}
      <button
        type="button"
        className={styles.close}
        onClick={onClose}
        aria-label={intl.formatMessage(editorMessages.close)}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
};

export const SMLUndoToast = TypedMemo(SMLUndoToastComponent);
